// extracted by mini-css-extract-plugin
export default {"textStyleWave":"routeInitiated_textStyleWave__KsC9X","wave":"routeInitiated_wave__3Fg9w"};